import React from 'react';

function UserSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#00253E"
        d="M11.833 14.806a3.838 3.838 0 003.833-3.833V9.431a3.837 3.837 0 00-3.833-3.833A3.837 3.837 0 008 9.431v1.542a3.837 3.837 0 003.833 3.833zM9.5 9.431a2.336 2.336 0 012.333-2.333 2.336 2.336 0 012.333 2.333v1.542a2.336 2.336 0 01-2.333 2.333A2.336 2.336 0 019.5 10.973V9.431z"
      ></path>
      <path
        fill="#00253E"
        d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 1.5c4.687 0 8.5 3.813 8.5 8.5a8.46 8.46 0 01-2.011 5.478c-1.697-.712-3.861-1.089-6.489-1.089-2.628 0-4.794.377-6.49 1.089A8.464 8.464 0 013.5 12c0-4.687 3.813-8.5 8.5-8.5zM6.692 18.628c1.423-.483 3.19-.739 5.308-.739s3.885.256 5.308.739A8.456 8.456 0 0112 20.5a8.456 8.456 0 01-5.308-1.872z"
      ></path>
    </svg>
  );
}

export default UserSvg;
